<div [@routerTransition]>

  <div class="row">

    <div class="columnfeatures1 colmd3">

      <div class="card paddin-left-5px" *ngIf="ShowList">

        <div class="card-header wh-header header3 padding-right-32px padding-bottom-0px padding-left-10px">

          <div class="row margin-top10px nav-link-hand">

            <label class="wh-header padding-left-5px font-weight-normal card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
              Features
            </label>

          </div>          
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          
          <div>
            <div class="chatsd product-chart-wrapper product-chat-height-650 agreement-chart-wrapper scroll padding-lrt ">
              <div class="row border-bottom rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" *ngFor="let l of modules" (click)="SelectedModule(l)">
                <div class="col-md-12 margin-top-5px margin-bottom-5px">

                  <div class="row">
                    <div class="col-md-12 padding-left-10px">
                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px f2">{{l.ModuleName}}</label>
                      </div>

                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px font-size-14 font-weight-normal">{{l.Description}}</label>
                      </div>

                    </div>

                  </div>

                </div>
              </div>


            </div>
          </div>

        </div>

      </div>
    </div>



    <div class="columnfeatures2">
      <div class="padding-right-0px background-white">
        <div class="">

          <div class="card my-profile-form top-link" *ngIf="ShowList2">
            <div class="card-header wh-header padding-bottom-6px">
              <div class="row">
                <div class="col-md-4 padding-left-10px" *ngIf="SelectedModuleDetails">
                  {{SelectedModuleDetails.ModuleName}}
                </div>
                <div class="col-md-8 padding-right-0px">
                  <div class="row">
                    <div class="offset-md-6 col-md-2 padding-right-0px text-align-right">
                      <a (click)="AddNewFeature()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Feature"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
                    </div>
                    <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
                      <form novalidate="" #f="ngForm" class="display-inherit">
                        <div class="clear-form">
                          <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">
                        </div>
                        <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px">Go</button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="card-body padding-top-0px padding-left-0px">

              <div class="row">
                <div class="col-md-12 padding-left-0px">
                  <div class="table-component">
                    <div class="table-responsive overflow-x">


                      <table class="table table-striped margin-left-zero"
                             cols="auto,2*,*,*,*,*,*,*">

                        <thead class="">
                          <tr>

                            <th class="">
                              Name
                            </th>

                            <th class="">
                              Short Name
                            </th>

                            <th class="">
                              Description
                            </th>

                            <th class="">
                              Feature Type
                            </th>

                            <th class="">
                              Status
                            </th>
                            <th class="">

                            </th>

                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let l of CurrentFeaturesController">

                            <td class=" td-padding-tb">{{l.FeatureName}}</td>
                            <td class=" td-padding-tb">{{l.ShortName}}</td>
                            <td class="td-padding-tb">{{l.FeatureDescription}}</td>
                            <td class=" td-padding-tb">{{l.FeatureType}}</td>
                            <td class="td-padding-tb ">{{l.FeatureStatus}}</td>
                            <td class=" td-padding-tb " hidden>
                              <button (click)="EditFeat()" type="submit" class="button-service-save padding-right-15px font-size-16px color-secondary nav-link-hand margin-left-3px"><i class="fas fa-pencil-alt"></i></button>
                              <a class="nav-link-hand font-size-16px color-Rejected" title="Remove"><i class="far fa-trash-alt nav-link-hand"></i></a>
                            </td>

                          </tr>

                        </tbody>

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card my-profile-form top-link" *ngIf="AddFeature">
            <div class="card-header wh-header padding-bottom-6px">
              <div class="col-md-12">
                <div class="row">
                  <!--<div class="display-inline">
                    <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel1()" title="Back To Module"><i class="fas fa-angle-double-left font-size-19px"></i></a>
                    Add New Feature To
                  </div>
                  <div class="display-inline">
                    <a class="color-blue">{{SelectedModuleDetails.ModuleName}}</a>
                  </div>-->
                  <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel1()" title="Back To Module"><i class="fas fa-angle-double-left font-size-19px"></i></a>
                  Add New Feature To <a class="color-blue padding-left-5px font-size-20px">{{SelectedModuleDetails.ModuleName}}</a>
                </div>
              </div>              

            </div>
            <div class="card-body padding-top-0px">

              <div>
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExample">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Features
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    (click)="SaveData()">Save
                            <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                        </div>


                      </div>

                      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                                </div>


                                <div class="col-md-3">
                                  <input type="text" class="form-control" id="Name" placeholder="Name"
                                         [(ngModel)]="Name"
                                         name="Name" #NameT="ngModel" />
                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Short Name</label>
                                </div>


                                <div class="col-md-3">
                                  <input type="text" class="form-control" id="ShortName" placeholder="Short Name"
                                         [(ngModel)]="ShortName"
                                         name="ShortName" #ShortNameT="ngModel" />
                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Description</label>
                                </div>


                                <div class="col-md-3">
                                  <input type="text" class="form-control" id="Description" placeholder="Description"
                                         [(ngModel)]="Description"
                                         name="Description" #DescriptionT="ngModel" />
                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Feature Type</label>
                                </div>


                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="FEATY" (ngModelChange)="onChange2($event)" id="FeatureType"
                                                 [(ngModel)]="FeatureType" SelectedValue="FeatureType" 
                                                 name="FeatureType">
                                  </CodeTypeValue>
                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Status</label>
                                </div>


                                <div class="col-md-3">
                                  <CodeTypeValue CodeType="RSTA" (ngModelChange)="onChange($event)" id="Status"
                                                 [(ngModel)]="Status" SelectedValue="Status" 
                                                 name="Status">
                                  </CodeTypeValue>
                                </div>

                              </div>


                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>

          <div class="card my-profile-form top-link" *ngIf="EditFeature">
            <div class="card-header wh-header padding-bottom-6px">
              <div class="col-md-12">
                <div class="row">
                  <a class="nav-link-hand  back-link left-arrow-treatmentcycle2 margin-right-5px" (click)="Cancel2()" title="Back To Module"><i class="fas fa-angle-double-left font-size-19px"></i></a>
                  Edit Feature
                </div>
              </div>              

            </div>
            <div class="card-body padding-top-0px">

              <div>
                <form class="form " novalidate="" #f="ngForm">
                  <div class="accordion" id="accordionExample">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                Features
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                        </div>


                      </div>

                      <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Name</label>
                                </div>


                                <div class="col-md-3">

                                  <input type="text" class="form-control" placeholder="Name"
                                         pattern="^[\0-9,._\-?]*$">

                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Short Name</label>
                                </div>


                                <div class="col-md-3">

                                  <input type="text" class="form-control" placeholder="Short Name"
                                         pattern="^[\0-9,._\-?]*$">

                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Description</label>
                                </div>


                                <div class="col-md-3">

                                  <input type="text" class="form-control" placeholder="Description"
                                         pattern="^[\0-9,._\-?]*$">

                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Feature Type</label>
                                </div>


                                <div class="col-md-3">

                                  <CodeTypeValue CodeType="CNTR"></CodeTypeValue>

                                </div>

                              </div>


                            </div>
                          </div>

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-top-auto margin-bottom-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Status</label>
                                </div>


                                <div class="col-md-3">

                                  <CodeTypeValue CodeType="CNTR"></CodeTypeValue>

                                </div>

                              </div>


                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>


  </div>


</div>



